import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getMyMenus } from '@/api/rbac/menu';
import { message } from 'ant-design-vue';

export const useMenuStore = defineStore('menu', () => {
  const menus = ref([]);
  const loading = ref(false);
  
  // 获取用户菜单
  const fetchMenus = async () => {
    loading.value = true;
    try {
      const res = await getMyMenus();
      menus.value = res.data || [];
      // 保存到 localStorage 用于菜单按需显示
      localStorage.setItem('userMenus', JSON.stringify(menus.value));
      return menus.value;
    } catch (error) {
      message.error('加载菜单失败');
      console.error('Failed to fetch menus:', error);
      return [];
    } finally {
      loading.value = false;
    }
  };
  
  // 从 localStorage 获取缓存的菜单
  const getMenusFromCache = () => {
    try {
      const cached = localStorage.getItem('userMenus');
      return cached ? JSON.parse(cached) : [];
    } catch (error) {
      console.error('Failed to parse cached menus:', error);
      return [];
    }
  };
  
  // 清除菜单数据
  const clearMenus = () => {
    menus.value = [];
    localStorage.removeItem('userMenus');
  };
  
  return {
    menus,
    loading,
    fetchMenus,
    getMenusFromCache,
    clearMenus,
  };
});
